import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import ImageGrid from './components/ImageGrid'
import Modal from './components/Modal'
import { gsap } from 'gsap'
import styles from "./components/ImageGrid2.module.css"
import GalleryNav from './components/GalleryNav'
import MeteFooter from './components/MeteFooter'
function PortfolioPage() {

    const [selectedImage, SetSelectedImage] = useState(null);


    useEffect(() => {
        document.title = "Portfolio | mete & design."; // or whatever is appropriate
      }, []);


    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } })
        });
        return () => {
            ctx.revert();
        };
    }, []);

    return (
        <div className={styles['Appi']}>

            <Container>
                <div className={styles['back']}>
                    
                        <GalleryNav />
                    
                    <div className={styles['mobileInfo']}><p>Please Open Site On Desktop for a better experience</p></div>
                </div>
                <ImageGrid SetSelectedImage={SetSelectedImage} />
                {selectedImage && <Modal selectedImage={selectedImage} SetSelectedImage={SetSelectedImage} showDetails={true} />}
            </Container>

            <MeteFooter />
        </div>

       
    )
}

export default PortfolioPage
